var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Button, Menu } from "@material-ui/core";
import Box from '@material-ui/core/Box';
import React, { useState } from "react";
import { ComplexFilterItemType } from "./api";
import NestedMenuItem from "./NestedMenuItem";
import { handleAction, handleActionResponse } from "./services/actions";
import { useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import * as objectPath from 'object-path';
var ComplexFilter = function (_a) {
    var items = _a.items, children = _a.children, filterData = _a.filterData, onFilterChanged = _a.onFilterChanged;
    var _b = __read(useState(null), 2), el = _b[0], setEl = _b[1];
    var _c = __read(useState(filterData || {}), 2), currentFilterData = _c[0], setCurrentFilterData = _c[1];
    useEffect(function () {
        setCurrentFilterData(filterData || {});
    }, [filterData]);
    var handleClose = function () { return setEl(null); };
    var handleClick = function (clickedItem) { return __awaiter(void 0, void 0, void 0, function () {
        var r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setEl(null);
                    return [4 /*yield*/, handleAction(clickedItem)];
                case 1:
                    r = _a.sent();
                    return [4 /*yield*/, handleActionResponse(r)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onConfirmItem = function (item, value) {
        var filter = {};
        if (value.indexOf('\n') > -1) {
            filter.in = value.split('\n');
        }
        else {
            if (value.substring(0, 1) == '<') {
                filter.greater = value.substring(1);
            }
            else if (value.substring(0, 1) == '>') {
                filter.lower = value.substring(1);
            }
            else if (value.substring(0, 1) == '=') {
                filter.equals = value.substring(1);
            }
            else {
                if (item.type == ComplexFilterItemType.Text) {
                    filter.contains = value;
                }
                else {
                    filter.equals = value;
                }
            }
        }
        objectPath.set(currentFilterData, item.path, filter);
        setCurrentFilterData(currentFilterData);
        if (onFilterChanged) {
            onFilterChanged(currentFilterData);
        }
        setEl(null);
    };
    var renderItem = function (childItem) {
        if (childItem.children.length == 0) {
            var filterComponent = void 0;
            if (childItem.type == ComplexFilterItemType.Text) {
                var value_1 = null;
                filterComponent = React.createElement("div", null,
                    React.createElement(TextField, { onKeyUp: function (e) { return e.stopPropagation(); }, onChange: function (e) { return value_1 = e.target.value; }, margin: "dense", variant: "outlined", InputLabelProps: { shrink: true } }),
                    React.createElement(Button, { onClick: function () { return onConfirmItem(childItem, value_1); } }, "Potvrdit"));
            }
            else if (childItem.type == ComplexFilterItemType.Boolean) {
                filterComponent = null;
            }
            else if (childItem.type == ComplexFilterItemType.Date) {
                filterComponent = null;
            }
            else if (childItem.type == ComplexFilterItemType.Enum) {
                filterComponent = null;
            }
            else if (childItem.type == ComplexFilterItemType.Number) {
                filterComponent = null;
            }
            return React.createElement(NestedMenuItem, { key: childItem.path, label: childItem.label, onClick: function () { return handleClick(childItem); }, parentMenuOpen: Boolean(el) },
                React.createElement(Box, { p: 2, onKeyDown: function (e) { return e.stopPropagation(); } }, filterComponent));
        }
        else {
            return React.createElement(NestedMenuItem, { key: childItem.path, label: childItem.label, onClick: function () { return handleClick(childItem); }, parentMenuOpen: Boolean(el) }, childItem.children.map(function (subItem, index) { return renderItem(subItem); }));
        }
    };
    return React.createElement(React.Fragment, null,
        React.createElement("div", { onClick: function (event) { return setEl(event.currentTarget); } }, children),
        React.createElement(Menu, { keepMounted: true, open: Boolean(el), anchorEl: el, getContentAnchorEl: null, onClose: handleClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'center',
            } }, items.map(function (childItem, index) { return renderItem(childItem); })));
};
export default ComplexFilter;
//# sourceMappingURL=ComplexFilter.js.map